module.exports = "/static/Images/pt-br/Tree.png";